import { useEffect } from "react";

const Demo = () => {
  useEffect(() => {
    document.title = "qwip in action - demo";
  }, []);

  return (
    <div className="min-h-[100dvh] w-full bg-background flex flex-col items-center justify-center px-4 py-8">
      <div className="w-full max-w-md flex flex-col items-center gap-6">
        <div className="text-center">
          <h1 className="font-funnel text-3xl tablet:text-4xl text-foreground">
            qwip in action
          </h1>
          <p className="font-dm text-sm text-muted-foreground mt-2">
            scan, unlock, focus.
          </p>
        </div>

        <div className="w-full aspect-[9/16] bg-black rounded-2xl overflow-hidden shadow-xl">
          <video
            className="w-full h-full object-cover"
            src="/videos/qwip-demo.mp4"
            controls
            autoPlay
            playsInline
            loop
            muted
          />
        </div>
      </div>
    </div>
  );
};

export default Demo;
